import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "buildingTypeModalElement",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = {
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close btn-sm",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1)
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "ID *", -1)
const _hoisted_12 = { class: "col-sm-10" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Name *", -1)
const _hoisted_16 = { class: "col-sm-10" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-sm-2 col-form-label py-0" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Image ")
const _hoisted_20 = { class: "col-sm-10" }
const _hoisted_21 = {
  key: 0,
  class: "input-group"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Max Nb. of Floors", -1)
const _hoisted_26 = { class: "col-sm-10" }
const _hoisted_27 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary col-2"
}, "OK", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)), ["prevent"])),
      class: _normalizeClass(_ctx.btnClass)
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.btnIcon || 'bi bi-plus')
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(_ctx.btnText), 1)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.modalTitle || 'New building Type'), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            })
          ]),
          (_ctx.errors.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row",
                    key: error
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(error.message || error), 1),
                      _hoisted_8
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: "was-validated",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["stop","prevent"]))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dto.id) = $event)),
                    type: "number",
                    step: "1",
                    min: "0",
                    class: "form-control",
                    required: "",
                    disabled: _ctx.buildingType
                  }, null, 8, _hoisted_13), [
                    [_vModelText, _ctx.dto.id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dto.name) = $event)),
                    type: "text",
                    class: "form-control",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.dto.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_FileUpload, {
                    title: 'Upload an Image',
                    "on-selected": _ctx.onFileSelectedForAsset
                  }, null, 8, ["on-selected"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.dto.image && _ctx.dto.image.startsWith('tmp://'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          type: "url",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dto.image) = $event)),
                          placeholder: "e.g. https://example.com",
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.dto.image]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dto.image = ''))
                        }, _hoisted_23)
                      ]))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dto.image) = $event)),
                        type: "url",
                        class: "form-control"
                      }, null, 512)), [
                        [_vModelText, _ctx.dto.image]
                      ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dto.maxFloors) = $event)),
                    type: "number",
                    step: "1",
                    min: "0",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.dto.maxFloors]
                  ])
                ])
              ])
            ]),
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary col-2",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Cancel"),
                  _hoisted_28
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ], 512)
  ], 64))
}